/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

export const TRANS_ERROR_UNNECESSARY_WELCOME = 'TRANS_ERROR_UNNECESSARY_WELCOME';
export const TRANS_ERROR_UNNECESSARY_LOGIN = 'TRANS_ERROR_UNNECESSARY_LOGIN';
export const TRANS_ERROR_USER_NOT_LOGGED_IN = 'TRANS_ERROR_USER_NOT_LOGGED_IN';
export const TRANS_ERROR_INSUFFICIENT_PERMISSIONS = 'TRANS_ERROR_INSUFFICIENT_PERMISSIONS';
export const TRANS_ERROR_CONTROLLER_DOWN = 'TRANS_ERROR_CONTROLLER_DOWN';
